<div class="timeline-nav">


  <div class="timeline-nav__row">
    <div class="timeline-nav__year">
      <div class="year-down" (click)="decrementYear()" [class.disabled]="minusBtnDisabled"></div>
      <div class="year-indicator" (click)="gotoYear()">
        <div class="year-text">{{currentYear}}</div>
      </div>
      <div class="year-up" (click)="incrementYear()" [class.disabled]="plusBtnDisabled"></div>
    </div>
    <div class="timeline-nav__subject-con">
      <ng-content></ng-content>
    </div>
  </div>


  @if (months != null) {
    <div class="timeline-nav__months">
      <ul>
        @for (mo of months; track mo; let i = $index) {
          <li (click)="scrollIntoView(currentYear, i+1)"  [ngClass]="{'hasData': mo.enabled}">
            <span>
              {{mo.monthLabel}}
            </span>
          </li>
        }
      </ul>
    </div>
  }

</div>
